module.exports = __webpack_public_path__ + "img/manajemen_rute.2754ef8e.svg";